<template>
  <sa-page-layout :btnConfigurazioniVisible="true" :linkConfigurazioni="linkConfigurazioni" :btnRefreshVisible="true" :showModalLoading="showModalLoading" :pathResource="pathResource" @refresh="onRefresh">
    <template slot="toolbar">
      <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovoTipoDocumento">
        <b-icon icon="plus"></b-icon>
        Nuovo
      </b-button>
    </template>
    <template slot="table-filter">
      <b-form @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <label class="sa-label-data">Struttura</label>
            <b-form-select v-model="filtroTipoDocumenti.codiceStruttura" :options="strutturaOptions" :value="null" value-field="codiceStruttura" text-field="denominazione" @input="onInputStrutture">
              <template #first>
                <b-form-select-option :value="null"> - Selezionare Struttura - </b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <label class="sa-label-data">Descrizione</label>
            <b-form-input v-model="filtroTipoDocumenti.descrizioneTipoDocumento" type="search" placeholder="Descrizione"></b-form-input>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
            <b-button type="submit" variant="info"> {{ this.$i18n.t("patients.lblFind") }}</b-button>
            <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
          </b-col>
        </b-row>
      </b-form>
    </template>
    <template slot="table-body">
      <configurazione-contabilita-tipo-documenti-list-component @afterLoadData="onAfterLoadData" ref="cmpConfigurazioneContabilitaTipoDocumentiListComponent"></configurazione-contabilita-tipo-documenti-list-component>
      <configurazione-contabilita-tipo-documenti-edit-modal-component
        ref="mdlConfigurazioneContabilitaTipoDocumentiEditModalComponent"
        @afterSave="onAfterSaveMdlConfigurazioneContabilitaTipoDocumentiEditModalComponent"
        @beforeSave="onBeforeSaveMdlConfigurazioneContabilitaTipoDocumentiEditModalComponent"
      ></configurazione-contabilita-tipo-documenti-edit-modal-component>
    </template>
  </sa-page-layout>
</template>

<script>
import ConfigurazioneContabilitaTipoDocumentiEditModalComponent from "../components/ConfigurazioneContabilitaTipoDocumentiEditModalComponent.vue";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ConfigurazioneContabilitaTipoDocumentiListComponent from "../components/ConfigurazioneContabilitaTipoDocumentiListComponent.vue";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
export default {
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  components: { SaPageLayout, ConfigurazioneContabilitaTipoDocumentiListComponent, ConfigurazioneContabilitaTipoDocumentiEditModalComponent },
  mixins: [StruttureMixin],
  data() {
    return {
      showModalLoading: false,
      pathResource: null,
      linkConfigurazioni: "/configurazionecontabilita",
      filtroTipoDocumenti: { codiceStruttura: null },
    };
  },
  mounted() {
    let sessionStorage = window.sessionStorage;
    let filtro = sessionStorage.getItem("filtroTipiDocumento");
    if (filtro) {
      this.filtroTipoDocumenti = JSON.parse(filtro);
    }
    this.$refs.cmpConfigurazioneContabilitaTipoDocumentiListComponent.loadData();
    this.struttureLoadData();
  },
  methods: {
    onClickNuovoTipoDocumento() {
      let me = this;
      me.$refs.mdlConfigurazioneContabilitaTipoDocumentiEditModalComponent.show({ codiceStruttura: null, tipoDocumento: null, codiceNumeratore: null });
    },
    onBeforeSaveMdlConfigurazioneContabilitaTipoDocumentiEditModalComponent() {},
    onRefresh() {
      this.filtra();
    },
    struttureLoadDataSuccess(response) {
      let me = this;
      me.strutturaOptions = response.data.data;
    },
    onAfterLoadData() {
      this.closeShowModalLoading();
    },
    filtra() {
      let sessionStorage = window.sessionStorage;
      sessionStorage.setItem("filtroTipiDocumento", JSON.stringify(this.filtroTipoDocumenti));
      this.$refs.cmpConfigurazioneContabilitaTipoDocumentiListComponent.loadData();
    },
    onInputStrutture() {},
    onSubmit() {
      this.filtra();
    },
    onReset() {
      this.filtroTipoDocumenti.codiceStruttura = null;
      this.filtroTipoDocumenti.descrizioneTipoDocumento = null;
      this.filtra();
    },
    onAfterSaveMdlConfigurazioneContabilitaTipoDocumentiEditModalComponent() {
      this.filtra();
    },
  },
};
</script>

<style></style>
